import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/** What the guard asks of the page: whether leaving now would throw work away. */
export interface LeaveAware {
  canLeave(): boolean;
}

/**
 * Leaving the appearance page discards the draft — the live preview is undone and the saved
 * look comes back — so an unsaved palette gets one question before it is lost. Its own file
 * rather than a member of the page so the route table does not have to load the page to
 * register the guard.
 */
export const unsavedThemeGuard: CanDeactivateFn<LeaveAware> = component => {
  if (component.canLeave()) return true;
  return confirm(inject(TranslateService).instant('SETTINGS.APPEARANCE.UNSAVED_CONFIRM'));
};
